export { UpdateAttendeesGroupEventsModal } from "./UpdateAttendeesGroupEventsModal";
